import React from 'react';
import { Provider } from 'react-redux';
import { CssBaseline } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Switcher from 'Elements/Switcher';
import store from 'Store';
import theme from '~/theme';
import ModalBase from './ModalBase';
import SnackbarBase from './SnackbarBase';
import { AppProvider } from './appContext';
import { AnalyticsProvider, useAnalyticsContext } from './analyticsContext';
import { MeetingProvider } from './meetingContext';

const App = () => {
  const analyticsContext = useAnalyticsContext();
  return (
    <React.Fragment>
      <Provider store={store}>
        <MuiThemeProvider theme={theme}>
        <CssBaseline />
          <AppProvider analyticsContext={analyticsContext}>
            <MeetingProvider analyticsContext={analyticsContext}>
              <Switcher />
              <ModalBase />
              <SnackbarBase />
            </MeetingProvider>
          </AppProvider>
        </MuiThemeProvider>
      </Provider>
    </React.Fragment>
  );
};

// hoist this so we can use analytics in our other providers
const AnalyticsWrappedApp = () => (
  <AnalyticsProvider>
    <App />
  </AnalyticsProvider>
);

export default AnalyticsWrappedApp;
